<template>
<!-- 底部文案 -->
    <div id="footerCom">
        <div style="height:50px"></div>
        <p>Copyright © 2014-2017 | 京ICP备15040773号-1</p>
        <p>北京华医共享医疗科技有限公司</p>
        <p style="color:red">
            <i class="el-icon-warning"></i>
            请谨慎操作，防止操作失误导致数据受损！
        </p>
    </div>
</template>
<script>
export default {
    name:'footerCom',
    props:['content'],
    mounted(){
    }
}
</script>
<style>
#footerCom{
    width:100%;
    height:200px;
    text-align: center;
    font-size: 14px;
    padding: 0 0 50px 0;
    box-sizing: border-box;
    background: white
}
#footerCom .list{
    width:50%;
    min-width:500px;
    max-width: 800px;
    list-style: none;
    display: flex;
    justify-content: space-around;
    margin:auto;
    padding-top:50px;
    box-sizing: border-box;
}
#footerCom .list li{
    cursor: pointer;
}
#footerCom .list li:hover{
    color:#1ba8f0;
}
#footerCom p{
    margin-top:20px;
}
</style>




// WEBPACK FOOTER //
// src/components/footer.vue